import { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import { isJWTVRentalOffer } from '@/features/jwtv-titles-rental/helpers/jwtv-titles-rental-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { useExperiment } from '@/libraries/experiment';
import { computed } from 'vue';

const currencyPrefixBy = {
	AU: 'A$ ',
	NZ: 'NZ$ ',
};

export type VariantPromoInfo = {
	code: string;
	queryParam: string;
	calculatePrice: (price: number) => string;
};

export function isJWTVPricingExpShouldBeActive(offer: TitleOfferFragment) {
	return isJWTVRentalOffer(offer) && !!offer.retailPriceValue && offer.retailPriceValue > 2;
}

export function useJWTVPricingExp() {
	const { activeVariant, experimentInfo } = useExperiment('EXP_JWTV_PRICING');
	const { country } = useLanguageStore();
	const countryCurrencyPrefix = computed(
		() => currencyPrefixBy[country.value as keyof typeof currencyPrefixBy] || ''
	);

	type VariantKey = Exclude<typeof activeVariant.value, null>;

	const promoCodesByVariant: Record<VariantKey, VariantPromoInfo> = {
		variant_1: {
			code: 'JWTV1DEAL',
			queryParam: 'v1',
			calculatePrice: (price: number) => countryCurrencyPrefix.value + (price - 1).toFixed(2),
		},
		variant_2: {
			code: 'JWTV20OFF',
			queryParam: 'v2',
			calculatePrice: (price: number) => countryCurrencyPrefix.value + (price * 0.8).toFixed(2),
		},
		variant_3: {
			code: 'JWTV50OFF',
			queryParam: 'v3',
			calculatePrice: (price: number) => countryCurrencyPrefix.value + (price * 0.5).toFixed(2),
		},
	};

	const activePromo = computed(() => {
		if (experimentInfo.value.activated) {
			return promoCodesByVariant[experimentInfo.value.variant as VariantKey];
		}
		return null;
	});

	return {
		jwtvPricingActiveVariant: activeVariant,
		activePromo,
	};
}
